<template>
  <div
    v-if="reviews"
    class="product-rating ruk_rating_snippet"
    :data-sku="sku"
  >
    <div
      v-if="reviews.count >= 1"
      class="product-rating__stars"
    >
      <i
        v-for="n of 5"
        :key="`ratings-${n}`"
        aria-hidden="true"
        :class="totalRatingClass(n)"
      />
    </div>
    <span
      v-if="reviews.count > 1"
      class="ruk-rating-snippet-count text-link"
      v-text="$string('collection.reviews',{replace: { count: reviews.count },})"
    />
    <span
      v-else-if="reviews.count === 1"
      class="ruk-rating-snippet-count text-link"
      v-text="$string('collection.review',{replace: { count: 1 },})"
    />
    <span
      v-else
      class="ruk-rating-snippet-count text-link"
      v-text="$string('collection.no_reviews')"
    />
  </div>
</template>

<script>

/**
 * Vue: Product rating (product-rating)
 * -----------------------------------------------------------------------------
 * Product rating from Review.io.
 *
 */
export default {
  name: 'ProductRating',

  props: {
    sku: {
      type: [Boolean, String],
      default: false,
      required: true,
    },
  },

  data() {
    return {
      reviews: false,
    }
  },

  watch: {
    sku() {
      this.review = false
      this.fetchReviews()
    },
  },

  mounted() {
    this.fetchReviews()
  },

  methods: {
    async fetchReviews() {
      const { ratingSnippet } = window
      const { reviewsIo } = window.cnvs.credentials

      if (!reviewsIo) {
        return
      }
      const hasReviewStore = reviewsIo.store && reviewsIo.store !== ''

      if (!ratingSnippet || !this.sku || !hasReviewStore) {
        return
      }

      try {
        await fetch(`https://api.reviews.io/product/reviews?store=${reviewsIo.store}&sku=${this.sku}`)
          .then(response => response.json())
          .then(rating => {
            this.reviews = rating
          })
      } catch (error) {
        this.reviews = false
        cnvs.ReportError('Failed to get product reviews', error)
      }

    },

    totalRatingClass(count) {
      const totalRating = Number(this.reviews.rating)
      const remainder = (totalRating % 1) * 100

      if (totalRating >= count) {
        return 'ruk-icon-percentage-star--100'
      }

      if (Math.ceil(totalRating) === count && remainder !== 0) {
        if (remainder <= 25) {
          return 'ruk-icon-percentage-star--25'
        }
        if (remainder <= 50) {
          return 'ruk-icon-percentage-star--50'
        }
        if (remainder <= 75 && remainder < 100) {
          return 'ruk-icon-percentage-star--75'
        }
      }

      return 'ruk-icon-percentage-star--0'

    },
  },
}
</script>

<style lang="scss">
@import './product-rating';
</style>
